import React from 'react';
import PropTypes from 'prop-types';
import searchIcon from '../../images/common/search.svg';
import {
  SearchContainer,
  SearchImage,
  SearchInput,
} from './styles/SearchBoxStyles';

/**
 * 検索アイコン付き入力ボックス
 * @component
 */
const SearchBox = ({
  placeholder,
  onChange,
  height,
  width,
  bgColor,
  defaultValue,
}) => (
  <SearchContainer>
    <SearchInput
      type="text"
      placeholder={placeholder}
      onChange={onChange}
      width={width}
      height={height}
      bgColor={bgColor}
      defaultValue={defaultValue}
    />
    <SearchImage src={searchIcon} alt="searchOperator" />
  </SearchContainer>
);

SearchBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  bgColor: PropTypes.string,
  defaultValue: PropTypes.string,
};

SearchBox.defaultProps = {
  placeholder: '',
  height: '24px',
  width: '200px',
  defaultValue: '',
  bgColor: '',
};

export default SearchBox;
